// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .raw-id-input {
        margin-top: 8px;
      }
      .raw-id-input__row {
        display: flex;
        gap: 8px;
        align-items: flex-start;
      }
      .raw-id-input__row textarea {
        flex: 1;
      }
      .raw-id-input__status {
        display: block;
        margin-top: 4px;
        color: #6c757d;
      }
    `, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
